import React from "react"
import PropTypes from "prop-types"

import LoaderSection from '../app_components/LoaderSection'
import StandardButton from '../app_components/StandardButton'
import ConnectSectionHeader from '../connect_sections/ConnectSectionHeader'
import ConvoTeaserItem from './ConvoTeaserItem'
import ChatContainer from './ChatContainer'
import { countUnreadConvos } from './convoUnread'

class ConvoListContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      dataLoaded: false,
      convoOpen: false,
      premiumUser: false,
    }

    this.loadConvos = this.loadConvos.bind(this)
    this.renderConvos = this.renderConvos.bind(this)
    this.openConvo = this.openConvo.bind(this)
    this.closeChat = this.closeChat.bind(this)
  }

  componentDidMount() {
    this.loadConvos()
  }

  loadConvos() {
    $.ajax({
      url: '../getUserConvos',
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json',
      },
      success: (data) => {
        this.setState({
          convos: JSON.parse(data.data.convos),
          old_convos_exist: JSON.parse(data.data.old_convos_exist),
          currentUser: JSON.parse(data.data.current_user),
          dataLoaded: true,
          premiumUser: data.data.premiumUser,
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this),
    })
  }

  renderConvos() {
    return this.state.convos.map((convo, i) => (
      <ConvoTeaserItem
        convo={convo}
        key={convo.id || i}
        openConvo={this.openConvo}
        currentUser={this.state.currentUser}
        missingImg={this.props.missingImg}
      />
    ))
  }

  renderEmptyState() {
    return (
      <>
        <div className="convosPageHeader">
          <ConnectSectionHeader
            icon="comment"
            iconSolid={true}
            title="Messages"
            subtitle="Chat with your Connects and keep the conversation going."
          />
        </div>
        <div className="convosEmpty">
          <p className="convosEmpty__text">
            No conversations yet — start chatting with one of your <strong>Connects</strong>!
          </p>
        </div>
        <div className="convosCta convosCta--inSection">
          <StandardButton
            text="Go to Connects"
            size="large"
            primary={true}
            icon="users-alt"
            iconSolid={false}
            fullWidth={true}
            onClick={() => window.location.assign('/connects')}
          />
        </div>
      </>
    )
  }

  renderOldConvosNotice() {
    if (!this.state.old_convos_exist) {
      return null
    }

    return (
      <div className="convosNotice">
        <p className="convosNotice__text">
          Missing older chats? Reconnect with past partners on{' '}
          <button
            type="button"
            className="convosNotice__link"
            onClick={() => window.location.assign('/connects')}
          >
            Connects
          </button>
          .
        </p>
      </div>
    )
  }

  renderConvoList() {
    const { convos, currentUser } = this.state
    const unreadCount = countUnreadConvos(convos, currentUser)
    const title = convos.length === 1 ? '1 Conversation' : `${convos.length} Conversations`

    return (
      <>
        <div className="convosPageHeader">
          <ConnectSectionHeader
            icon="comment"
            iconSolid={true}
            title={title}
            subtitle={unreadCount > 0 ? `${unreadCount} unread conversation${unreadCount === 1 ? '' : 's'}` : 'Tap a conversation to open chat'}
          />
        </div>
        <div className="convosList">
          {this.renderConvos()}
        </div>
        {this.renderOldConvosNotice()}
      </>
    )
  }

  openConvo(convoId) {
    this.setState({
      convoOpen: true,
      convoIdOpen: convoId,
    })
  }

  closeChat() {
    this.loadConvos()
    this.setState({
      convoOpen: false,
      convoIdOpen: '',
    })
  }

  render() {
    if (!this.state.dataLoaded) {
      return <LoaderSection />
    }

    if (this.state.convoOpen) {
      return (
        <ChatContainer
          convoId={this.state.convoIdOpen}
          closeChat={this.closeChat}
          missingImg={this.props.missingImg}
          currentUser={this.state.currentUser}
        />
      )
    }

    const hasConvos = this.state.convos && this.state.convos.length > 0

    return (
      <div className="convosPage">
        {hasConvos ? this.renderConvoList() : (
          <>
            {this.renderEmptyState()}
            {this.renderOldConvosNotice()}
          </>
        )}
      </div>
    )
  }
}

ConvoListContainer.propTypes = {
  missingImg: PropTypes.string.isRequired,
}

export default ConvoListContainer
